"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const keautils_1 = require("keautils");
const keautils_2 = require("keautils");
const botones_1 = require("../../botones");
const table_1 = require("../../table");
class ColumnMappingComponent extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.value = (props) => props.value;
        this.count = keautils_1.createSelector(this.value, x => x.length);
        this.columnas = (props) => props.columnas;
        /**Indices y titulos de las columnas que NO estan mapeadas */
        this.columnasDisponibles = keautils_1.createSelector(this.value, this.columnas, (mapping, columnas) => keautils_2.pipe(columnas, cols => keautils_2.enumObject(cols), cols => cols.filter(x => !keautils_2.contains(mapping, x.key))));
        /**Indices y titulos de las columnas que SI estan mapeadas, en el orden de mapeo */
        this.columnasAgregadas = keautils_1.createSelector(this.value, this.columnas, (mapping, columnas) => mapping.map(key => ({ key, value: columnas[key] })));
        this.agregarColumna = (col) => {
            const newValue = [...this.props.value, col];
            this.props.onChange(newValue);
        };
        this.moverColumna = (indiceMapping, direccion) => {
            const newValue = keautils_2.upDownItem(this.props.value, indiceMapping, direccion);
            this.props.onChange(newValue);
        };
        this.quitarColumna = (indice) => {
            const newValue = this.props.value.filter(x => x != indice);
            this.props.onChange(newValue);
        };
        this.handleTodas = () => {
            this.props.onChange(undefined);
        };
        this.handleNinguna = () => {
            this.props.onChange([]);
        };
    }
    render() {
        const columnasDisponibles = this.columnasDisponibles(this.props).map(col => React.createElement("tr", { key: col.key },
            React.createElement("td", null,
                React.createElement(botones_1.Link, { iconClass: "fa fa-plus fa-fw", onClick: () => this.agregarColumna(col.key), style: "success" })),
            React.createElement("td", null, col.value ? col.value : React.createElement("i", null, col.key))));
        const columnasAgregadas = this.columnasAgregadas(this.props).map((col, indiceMapping) => React.createElement("tr", { key: col.key },
            React.createElement("td", null,
                React.createElement(botones_1.Link, { iconClass: "fa fa-times fa-fw", onClick: () => this.quitarColumna(col.key), style: "danger" }),
                React.createElement(botones_1.Link, { iconClass: "fa fa-arrow-up fa-fw", onClick: () => this.moverColumna(indiceMapping, "up") }),
                React.createElement(botones_1.Link, { iconClass: "fa fa-arrow-down fa-fw", onClick: () => this.moverColumna(indiceMapping, "down") })),
            React.createElement("td", null, col.value ? col.value : React.createElement("i", null, col.key))));
        const ninguna = React.createElement(botones_1.Button, { iconClass: "fa fa-square-o", style: "danger", onClick: this.handleNinguna }, "Ninguna");
        const todas = React.createElement(botones_1.Button, { iconClass: "fa fa-check-square-o fa-fw", style: "success", onClick: this.handleTodas }, "Todas");
        return (React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
            React.createElement("div", { style: { flex: "0 1 auto" } },
                React.createElement("div", { className: "btn-group pull-right" },
                    ninguna,
                    todas)),
            React.createElement("div", { style: { display: "flex", flex: 1 } },
                React.createElement("div", { style: { flex: 1 } },
                    React.createElement("label", null, "Disponibles"),
                    React.createElement(table_1.Table, { header: React.createElement("tr", null,
                            React.createElement("td", null),
                            React.createElement("td", null)), items: columnasDisponibles })),
                React.createElement("div", { style: { flex: 1 } },
                    React.createElement("label", null, "Seleccionadas"),
                    React.createElement(table_1.Table, { header: React.createElement("tr", null,
                            " ",
                            React.createElement("td", null),
                            " ",
                            React.createElement("td", null),
                            " "), items: columnasAgregadas })))));
    }
}
exports.ColumnMappingComponent = ColumnMappingComponent;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/components/mappingComp.js
// module id = 504
// module chunks = 0